import React from 'react';
import { Typography } from '@mui/material';

import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
  root: {
    marginTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
    '& p': {
      marginBottom: theme.spacing(3)
    },
    '& h2': {
      marginBottom: theme.spacing(2)
    }
  }
}));

const SupplierCodeOfConductPage = (): JSX.Element | null => {
  const classes = useStyles();

  return (
    <div className={classes.root} data-testid="supplier-code-of-conduct-page">
      <Typography variant="h1" gutterBottom>
        Pizza Hut Supplier Code of Conduct
      </Typography>
      <Typography paragraph>
        YUM! Brands, Inc. (<abbr title="YUM! Brands, Inc.">&quot;Yum&quot;</abbr>) is committed to conducting its business in an ethical, legal and socially responsible manner. To encourage compliance with all legal requirements and ethical business practices, Yum has established this Supplier Code of Conduct (the <abbr title="Supplier Code of Conduct">&quot;Code&quot;</abbr>) for Yum&apos;s U.S. suppliers (<abbr title="Yum's U.S. suppliers">&quot;Suppliers&quot;</abbr>).
      </Typography>
      <Typography variant="h2" gutterBottom>
        Compliance With Laws And Regulations
      </Typography>
      <Typography paragraph>
        Suppliers are required to abide by all applicable laws, codes or regulations including, but not limited to, any local, state or federal laws regarding wages and benefits, workmen&apos;s compensation, working hours, equal opportunity, worker and product safety. Yum also expects that Suppliers will conform their practices to the published standards for their industry.
      </Typography>
      <Typography variant="h2" gutterBottom>
        Employment Practices
      </Typography>
      <Typography variant="h3" gutterBottom>
        Working Hours & Conditions
      </Typography>
      <Typography paragraph>
        In compliance with applicable laws, regulations, codes and industry standards, Suppliers are expected to ensure that their employees have safe and healthy working conditions and reasonable daily and weekly work schedules. Employees should not be required to work more than the number of hours allowed for regular and overtime work periods under applicable local, state and federal law.
      </Typography>
      <Typography variant="h3" gutterBottom>
        Nondiscrimination
      </Typography>
      <Typography paragraph>
        Suppliers should implement a policy to effectuate all applicable local and federal laws prohibiting discrimination in hiring and employment on the grounds of race, color, religion, sex, age, physical disability, national origin, creed or any other basis prohibited by law.
      </Typography>
      <Typography variant="h3" gutterBottom>
        Child Labor
      </Typography>
      <Typography paragraph>
        Suppliers should not use workers under the legal age for employment for the type of work being performed in any facility in which the Supplier is doing work for Yum. In no event should Suppliers use employees younger than 14 years of age.
      </Typography>
      <Typography variant="h3" gutterBottom>
        Forced and Indentured Labor
      </Typography>
      <Typography paragraph>
        In accordance with applicable law, no Supplier should perform work or produce goods for Yum using labor under any form of indentured servitude, nor should threats of violence, physical punishment, confinement or other form of physical, sexual, psychological or verbal harassment or abuse be used as a method of discipline or control.
      </Typography>
      <Typography variant="h3" gutterBottom>
        Notification to Employees
      </Typography>
      <Typography paragraph>
        To the extent required by law, Suppliers should establish companywide policies implementing the standards outlined in this Code and post notices of those policies for their employees. The notices should be in all languages necessary to fully communicate the policy to its employees.
      </Typography>
      <Typography variant="h2" gutterBottom>
        Audits And Inspections
      </Typography>
      <Typography paragraph>
        Each Supplier should conduct audits and inspections to ensure its compliance with this Code and applicable legal and contractual standards. In addition to any contractual rights of Yum or Unified Foodservice Purchasing Co-op, LLC (<abbr title="Unified Foodservice Purchasing Co-op, LLC">&quot;UFPC&quot;</abbr>), the Supplier&apos;s failure to observe the Code may subject it to disciplinary action, which could include termination of the Supplier relationship. The business relationship with Yum and UFPC is strengthened upon full and complete compliance with the Code and the Supplier&apos;s agreements with Yum and UFPC.
      </Typography>
      <Typography variant="h2" gutterBottom>
        Application
      </Typography>
      <Typography paragraph>
        The Code is a general statement of Yum&apos;s expectations with respect to its Suppliers. The Code should not be read in lieu of but in addition to the Supplier&apos;s obligations as set out in any agreements between Yum or UFPC and the Supplier. In the event of a conflict between the Code and an applicable agreement, the agreement shall control.
      </Typography>
    </div>
  );
};

export default SupplierCodeOfConductPage;
